const initialState = {
	userInfo: {},
};

const commonReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_USER_INFO':
			return {
				...state,
				userInfo: action.payload,
			};
		default:
			return state;
	}
};

export default commonReducer;
